var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WebPanel',{attrs:{"id":"app","navigation":_vm.navigation,"user":{ name: 'Jamie Geissmann' },"dropdownItems":_vm.dropdownItems}},[_c('Icon'),_c('ProjectIcons'),_c('RouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }